export default __webpack_public_path__ + "static/media/002-check up.bf747db5.svg";